import VueCookies from 'vue-cookies'
import { loginApi, registerApi, sendCodeApi } from '@/api/index'

const getUserInfo = () => {
  try {
    return JSON.parse(localStorage.getItem('userInfo')) || null;
  } catch (e) {
    return null;
  }
};

const getStoredToken = () => {
  const userInfo = getUserInfo();
  return VueCookies.get('web_token') || (userInfo && userInfo.token) || '';
};

const token = getStoredToken();
if (!token) localStorage.removeItem('userInfo');

const state = {
  token,
  userInfo: token ? getUserInfo() : null,
  loginPromptSeq: 0
};

const getters = {
  isLogged: state => !!state.token,
  userInfo: state => state.userInfo,
  username: state => (state.userInfo && (state.userInfo.nickname || state.userInfo.phone)) || '青叶用户',
  loginPromptSeq: state => state.loginPromptSeq
};

const mutations = {
  SET_LOGIN(state, { token, userInfo }) {
    state.token = token;
    state.userInfo = userInfo;
    VueCookies.set('web_token', token, '7d');
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  CLEAR_LOGIN(state) {
    state.token = '';
    state.userInfo = null;
    VueCookies.remove('web_token');
    localStorage.removeItem('userInfo');
  },
  PROMPT_LOGIN(state) {
    state.loginPromptSeq += 1;
  }
};

const actions = {
  sendCode({ commit }, payload) {
    return sendCodeApi({
      phone: payload.phone,
      scene: payload.scene || 'login'
    }).then(res => {
      if (res.code !== 0) {
        return Promise.reject(res);
      }
      return res.data;
    });
  },
  login({ commit }, payload) {
    return loginApi({
      phone: payload.phone,
      password: payload.password,
      code: payload.code,
      loginType: payload.loginType || 'password'
    }).then(res => {
      if (res.code !== 0) {
        return Promise.reject(res);
      }
      commit('SET_LOGIN', { token: res.data.token, userInfo: res.data });
      return res.data;
    });
  },
  register({ commit }, payload) {
    return registerApi({
      phone: payload.phone,
      code: payload.code,
      password: payload.password
    }).then(res => {
      if (res.code !== 0) {
        return Promise.reject(res);
      }
      return res.data;
    });
  },
  logout({ commit }) {
    commit('CLEAR_LOGIN');
  },
  expireLogin({ commit }) {
    commit('CLEAR_LOGIN');
    commit('PROMPT_LOGIN');
    try {
      const ElementUI = require('element-ui');
      if (ElementUI.MessageBox && ElementUI.MessageBox.close) {
        ElementUI.MessageBox.close();
      }
    } catch (e) {}
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js